module.exports = __webpack_public_path__ + "img/student_11.1e2e8f1b.png";